import * as React from 'react';
export var SelectContext = React.createContext(null);